import React from "react";
import ModalShell from "../common/ModalShell";
import styles from "./ProfileDrawers.module.css";

// Only the pages that exist on nodel.co.za; add privacy / PAIA links once they are published.
const POLICIES = [
  { title: "Terms of service", sub: "Your agreement with Nodel", href: "https://nodel.co.za/terms/" },
  { title: "Payment terms", sub: "Billing, invoices and renewals", href: "https://nodel.co.za/payment-terms/" },
];

export default function TermsModal({ onClose }) {
  return (
    <ModalShell onClose={onClose} overlayClassName={styles.modalOverlay}>
      <div className={styles.modal} role="dialog" aria-label="Terms and policies" onClick={(e) => e.stopPropagation()}>
        <header className={styles.modalHead}>
          <h2>Terms &amp; policies</h2>
          <button type="button" className={styles.close} aria-label="Close" onClick={onClose}>×</button>
        </header>
        {POLICIES.map((p) => (
          <a key={p.title} className={styles.policy} href={p.href} target="_blank" rel="noopener noreferrer">
            <span><strong>{p.title}</strong><small>{p.sub}</small></span>
            <span aria-hidden="true">↗</span>
          </a>
        ))}
        <p className={styles.muted}>Nodel is operated in South Africa. Personal information is processed under POPIA.</p>
      </div>
    </ModalShell>
  );
}
